import { render, staticRenderFns } from "./SimpleBanner.vue?vue&type=template&id=545459aa&"
import script from "./SimpleBanner.vue?vue&type=script&lang=js&"
export * from "./SimpleBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports